import { HttpApiService } from "@/shared/services/httpApi.service";

import { AUTH_API_ENDPOINTS } from "../constants/auth.constants";
import type {
  AcceptInvitationRequest,
  AcceptInvitationResponse,
  VerifyInvitationResponse,
} from "../types/invitation.types";

/**
 * Public organization-invitation endpoints (`/auth/invitations/*`, no session required). `verify` validates
 * the magic link before showing the form; `accept` consumes the single-use token, creates the user and logs
 * them in (the 201 sets the session cookies, mirroring `/auth/login`). Both endpoints return ONE generic 400
 * for invalid/expired/used links — the backend deliberately does not distinguish, for security.
 */
export const invitationService = {
  verify: async (email: string, token: string): Promise<VerifyInvitationResponse> => {
    const response = await HttpApiService.get<VerifyInvitationResponse>(
      AUTH_API_ENDPOINTS.INVITATION_VERIFY,
      { params: { email, token } },
    );
    return response.data;
  },

  accept: async (body: AcceptInvitationRequest): Promise<AcceptInvitationResponse> => {
    const response = await HttpApiService.post<AcceptInvitationResponse, AcceptInvitationRequest>(
      AUTH_API_ENDPOINTS.INVITATION_ACCEPT,
      body,
    );
    return response.data;
  },
};
